import { useEffect, useRef } from 'react';
const CHANNEL = 'uxp-auth-channel';
export function broadcastAuthEvent(event) {
    try {
        const bc = new BroadcastChannel(CHANNEL);
        bc.postMessage(event);
        bc.close();
    }
    catch ( /* BroadcastChannel not available */_a) { /* BroadcastChannel not available */ }
}
export const DEFAULT_LOGIN_URL = '/view/auth/login';
// loginUrl: the host's login page (context.loginUrl). A v4 host sends its own; v5 uses the default.
export function redirectToLogin(withNext = false, loginUrl) {
    const next = withNext
        ? '?next=' + encodeURIComponent(window.location.pathname + window.location.search)
        : '';
    // replace(), not href: the current history entry is replaced so Back does not return to
    // a page this visitor may not see (a bfcache-restored render of a private page).
    window.location.replace(`${loginUrl || DEFAULT_LOGIN_URL}${next}`);
}
export function useAuthBroadcastListener(onEvent, skip = false) {
    const onEventRef = useRef(onEvent);
    useEffect(() => { onEventRef.current = onEvent; });
    useEffect(() => {
        if (skip)
            return;
        let bc;
        try {
            bc = new BroadcastChannel(CHANNEL);
            bc.onmessage = (e) => onEventRef.current(e.data);
        }
        catch (_a) { }
        return () => { try {
            bc === null || bc === void 0 ? void 0 : bc.close();
        }
        catch (_a) { } };
    }, [skip]);
}
